
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whitepapers",
      function () {
        return require("private-next-pages/whitepapers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whitepapers"])
      });
    }
  